export const lists = {
  // Lists Page
  listsPageTitle: 'Lists',
  lists: 'My Lists',
  noLists: 'No lists found',
  addList: 'Add List',
  editList: 'Edit List',
  deleteList: 'Delete List',
  searchLists: 'Search lists...',
  filterLists: 'Filter Lists',
  clearFilters: 'Clear Filters',
  loading: 'Loading...',
  
  // List Details
  listDetails: 'List Details',
  viewDetails: 'View Details',
  duplicate: 'Duplicate List',
  close: 'Close',
  
  // Categories
  categories: 'Categories',
  category: 'Category',
  general: 'General',
  shopping: 'Shopping',
  travel: 'Travel',
  work: 'Work',
  personal: 'Personal',
  other: 'Other',
  allCategories: 'All Categories',
  selectCategory: 'Select a category',
  
  // List Form
  listTitle: 'Title',
  description: 'Description',
  color: 'Color',
  cancel: 'Cancel',
  save: 'Save',
  
  // List Items
  addItem: 'Add Item',
  editItem: 'Edit Item',
  deleteItem: 'Delete Item',
  itemTitle: 'Item Title',
  itemDescription: 'Description (optional)',
  markCompleted: 'Mark as completed',
  markPending: 'Mark as pending',
  noItems: 'No items in this list yet',
  
  // Templates
  useAsTemplate: 'Use as Template',
  saveAsTemplate: 'Save as Template',
  templates: 'Templates',
  createFromTemplate: 'Create from Template',
  
  // Priorities
  priority: 'Priority',
  lowPriority: 'Low',
  mediumPriority: 'Medium',
  highPriority: 'High',
  
  // Tags
  tags: 'Tags',
  addTag: 'Add tag',
  removeTag: 'Remove tag',
  
  // Sub-tasks
  addSubtask: 'Add Subtask',
  subtasks: 'Subtasks',
  parentTask: 'Parent Task',
  
  // Template Categories
  household: 'Household',
  wellness: 'Wellness',
  
  // Progress
  progress: 'Progress',
  completed: 'Completed',
  pending: 'Pending',
  totalItems: 'Total Items',
  
  // Export & Print
  export: 'Export',
  exportAsPDF: 'Export as PDF',
  exportAsText: 'Export as Text',
  printList: 'Print List',
  
  // Notifications
  listCreated: 'List created successfully',
  listUpdated: 'List updated successfully',
  listDeleted: 'List deleted successfully',
  itemAdded: 'Item added successfully',
  itemUpdated: 'Item updated successfully',
  itemDeleted: 'Item deleted successfully',
  
  // Confirmations
  confirmDeleteList: 'Are you sure you want to delete this list?',
  confirmDeleteItem: 'Are you sure you want to delete this item?',
  
  // Validation
  titleRequired: 'Title is required',
  itemTitleRequired: 'Item title is required',
  
  // Authentication
  authRequired: 'Authentication Required',
  pleaseLoginToViewLists: 'Please log in to view and manage your lists',
};